import {trackObservabilityIssueAlertClick} from '../../services/analytics/observabilityEvents';
import {type AnnotationItem, EMPTY_ANNOTATIONS} from '../vis/annotations';
import {type GraphAnnotations} from './graphRenderProps';
import {type IssueMarkerStateInputs} from './issueMarkerViewProps';

/** Application issue actions stay at the adapter boundary. */
export function getGraphAnnotations(
  items: AnnotationItem[] | undefined,
  inputs: IssueMarkerStateInputs
) {
  const {
    activeIssueCount,
    annotationActive,
    entityName,
    handleIssueInteraction,
    hoveredIssueSource,
    issueRampStatus,
    openWorkspaceDrawer,
    projectName,
    setSelectedIssue,
    xAxisMax,
    xAxisMin,
  } = inputs;
  function onHover(id: string | null) {
    handleIssueInteraction(id == null ? 'unhover' : 'hover', id)();
  }
  function onSelect(id: string) {
    trackObservabilityIssueAlertClick({
      action: 'Click issue alert',
      entityName: entityName ?? '',
      projectName: projectName ?? '',
    });
    openWorkspaceDrawer?.('run-issues');
    setSelectedIssue(id);
  }
  return {
    items: items ?? EMPTY_ANNOTATIONS,
    activeCount: activeIssueCount,
    isActive: annotationActive,
    isEnabled: issueRampStatus === 'enabled',
    markerQueryXMax: xAxisMax,
    markerQueryXMin: xAxisMin,
    readHoveredId: hoveredIssueSource.get,
    subscribeToHover: hoveredIssueSource.subscribe,
    onHover,
    onActivate: onSelect,
  } satisfies GraphAnnotations;
}
